import {CssBaseline, ThemeProvider, useMediaQuery} from "@mui/material";
import {Route, Routes} from "react-router-dom";
import './App.css';
import {adeccoTheme} from "./theme/adeccoTheme";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Home from "./pages/Home";
import User from "./pages/User";
import axios from "axios";
import AuthService from "./services/auth.service";
import Mobile from "./pages/Mobile";

function App() {
    axios.interceptors.request.use(
        config => {
            const token = AuthService.getToken()
            if (token) {
                config.headers.authorization = `Bearer ${token}`;
            }
            return config;
        },
        error => {
            return Promise.reject(error)
        }
    );

  return (
      <ThemeProvider theme={adeccoTheme}>
          <CssBaseline/>
          <Routes>
              <Route path={'/login'} element={<Login/>}/>
              <Route path={'/checkin'} element={<Mobile/>}></Route>
              <Route element={<ProtectedRoute user={localStorage.user}/>}>
                <Route path={'/'} element={<Home/>}/>
                <Route path={'/user/:id'} element={<User/>}/>
              </Route>
          </Routes>

      </ThemeProvider>
  );
}

export default App;
